











































import Vue, { PropType } from 'vue';

export interface FormDataInterface {
  title?: string;
}

export default Vue.extend({
  props: {
    section: {
      // FIXME update generated format
      // type: Object as () => CvSectionGallery,
      type: Object as PropType<any>,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { title } = this.section;
    return {
      formData: { title } as FormDataInterface,
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
